var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  stroke: "black"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.3307 13.384V20.1183C23.3307 20.545 23.1673 20.9095 22.8398 21.2124C22.5122 21.5153 22.1195 21.6668 21.6608 21.6668H8.33396C7.87592 21.6668 7.48255 21.5153 7.15503 21.2124C6.82812 20.9095 6.66406 20.545 6.66406 20.1183V13.384L15.0136 16.8183L23.3307 13.384ZM23.3307 12.3404L15.0136 15.8086L6.66406 12.3404V9.88257C6.66406 9.45589 6.82812 9.09079 7.15503 8.78787C7.48255 8.48496 7.87592 8.3335 8.33396 8.3335H21.6608C22.1195 8.3335 22.5122 8.48496 22.8398 8.78787C23.1673 9.09079 23.3307 9.45589 23.3307 9.88257V12.3404Z",
  fill: "black"
})));
export default SvgIconEmail;